import useWalletConnector from '@/src/components/AppComponents/WalletConnector/useWalletConnector';
import { Button } from '@/src/components/Commons/Button';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { FundWithDetailsEntity, SwapOfferEntity } from '@/src/lib/MayzSmartDB';
import { useTokensStore } from '@/src/store';
import { hexToStr } from '@/src/lib/MayzSmartDB';
import { showToken_Amount_NotRounded, showToken_Amount_Rounded } from '@/src/store/global/tokensStoreModelHelpers';

interface BtnConfirmationProps {
    isBuy: boolean;
    fund: FundWithDetailsEntity;
    isLoadingSwapOffers: boolean;
    isTokensStoreReady: boolean;
    isAddingTokens: boolean;
    swapOffer: SwapOfferEntity | undefined;
    swapOffers: SwapOfferEntity[];
    amount_toGive: bigint;
    amount_toGet: bigint;
    commission: bigint;
    isValidTx: boolean;
    isProcessingTx: boolean;
    setShowProcessingTx: (show: boolean) => void;
    setShowUserConfirmation: (show: boolean) => void;
}

export default function BtnConfirmation(props: BtnConfirmationProps) {
    //--------------------------------------
    const { walletStore } = useWalletConnector();
    //--------------------------------------
    const tokensStore = useTokensStore();
    //--------------------------------------
    const {
        isBuy,
        fund,
        isLoadingSwapOffers,
        isTokensStoreReady,
        isAddingTokens,
        swapOffer,
        swapOffers,
        amount_toGive,
        amount_toGet,
        isValidTx,
        isProcessingTx,
        setShowProcessingTx,
        setShowUserConfirmation,
    } = props;
    //--------------------------------------
    return (
        <>
            {walletStore.isConnected === true ? (
                isTokensStoreReady === true && isAddingTokens === false && walletStore.isWalletDataLoading === false ? (
                    swapOffer !== undefined ? (
                        <>
                            {isBuy === true ? (
                                <Button
                                    mode="filled"
                                    disabled={isValidTx === false}
                                    arrow={false}
                                    onClick={() => {
                                        isProcessingTx === true ? setShowProcessingTx(true) : setShowUserConfirmation(true);
                                    }}
                                >
                                    {isProcessingTx === true ? (
                                        <>
                                            <LoaderButton classNameStyle={'black'} />
                                            PROCESSING...
                                        </>
                                    ) : (
                                        // `BUY ${showToken_Amount_NotRounded(tokensStore, amount_toGet, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}`
                                        `BUY ${showToken_Amount_Rounded(tokensStore, amount_toGet, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}`
                                    )}
                                </Button>
                            ) : (
                                <Button
                                    mode="filled"
                                    disabled={isValidTx === false}
                                    arrow={false}
                                    onClick={() => {
                                        isProcessingTx === true ? setShowProcessingTx(true) : setShowUserConfirmation(true);
                                    }}
                                >
                                    {isProcessingTx === true ? (
                                        <>
                                            <LoaderButton classNameStyle={'black'} />
                                            PROCESSING...
                                        </>
                                    ) : (
                                        // `SELL ${showToken_Amount_NotRounded(tokensStore, amount_toGive, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}`
                                        `SELL ${showToken_Amount_Rounded(tokensStore, amount_toGive, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}`
                                    )}
                                </Button>
                            )}
                        </>
                    ) : isLoadingSwapOffers === false && swapOffers.length > 0 ? (
                        <Button mode="filled" disabled={true} arrow={false}>
                            SELECT OFFER TO {isBuy ? `BUY ${hexToStr(fund.fdFundFT_TN_Hex)}` : `SELL ${hexToStr(fund.fdFundFT_TN_Hex)}`}
                        </Button>
                    ) : isLoadingSwapOffers === false && swapOffers.length === 0 ? (
                        <Button mode="filled" disabled={true} arrow={false}>
                            NO OFFER AVAILABLE TO {isBuy ? `BUY ${hexToStr(fund.fdFundFT_TN_Hex)}` : `SELL ${hexToStr(fund.fdFundFT_TN_Hex)}`}
                        </Button>
                    ) : (
                        <Button mode="filled" disabled={true} arrow={false}>
                            <LoaderButton classNameStyle={'black'} />
                            LOADING...
                        </Button>
                    )
                ) : (
                    <Button mode="filled" disabled={true} arrow={false}>
                        <LoaderButton classNameStyle={'black'} />
                        LOADING...
                    </Button>
                )
            ) : (
                <Button mode="filled" disabled={true} arrow={false}>
                    CONNECT WALLET TO {isBuy ? `BUY ${hexToStr(fund.fdFundFT_TN_Hex)}` : `SELL ${hexToStr(fund.fdFundFT_TN_Hex)}`}
                </Button>
            )}
        </>
    );
}
